import { useEffect } from "react";
import closeIcon from "/icons/close.svg";
import { Modal } from "./Modal";

export const SuccessModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div className="bg-white w-full">
        <div className="flex justify-between items-start gap-2 pb-6 border-slate-200 border-b">
          <h5 className="font-PensumPro font-medium text-textDefault text-lg lg:text-2xl">
            Success!
          </h5>
          <div onClick={() => setIsOpen(false)} className="min-w-6 cursor-pointer">
            <img className="w-6 h-6" src={closeIcon} alt="" />
          </div>
        </div>
        <div className="p-6 overflow-y-auto scroll">
          <h5 className="font-PensumPro font-medium text-textDefault text-lg lg:text-2xl text-center">
            Your signature has been copied to your clipboard.
          </h5>
          <p className="py-4 text-textDefault text-lg text-center">
            To use your new signature in the Outlook on the Web, please visit:
            <br />
            <br />
            <a
              className="text-motion600 underline"
              target="_blank"
              href="https://outlook.office.com/mail/options/accounts-category/signatures-subcategory"
            >
              https://outlook.office.com/mail/options/accounts-category/signatures-subcategory
            </a>
            <br />
            <br />
            and paste your new signature into the text field.
          </p>
          <img src="/images/outlook-signature.png" alt="" />
        </div>
      </div>
    </Modal>
  );
};
